import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`

:root {
    
    --maxWidth: 1280px;
    --white: #fff;
    --primaryColor:rgba(161, 198, 237);
    --secondaryColor:rgba(213, 225, 237);
    --lightGrey: #eee;
    --medGrey: #353535;
    --darkGrey: #1c1c1c;
    --fontSuperBig: 2.5rem;
    --fontBig: 1.5rem;
    --fontMed: 1.2rem;
    --fontSmall: 1rem;
}

* {
    box-sizing: border-box;
    font-family: 'Abel', sans-serif;
}
element.style{
    background-color: var(--secondaryColor)
}
.datepick{
    display: flex;
    align-items: center;
 
  background: var(--Grey);
  padding: 0 20px;
  z-index:1;
}
body {
   

    h1 {
        font-size: 2rem;
        font-weight: 600;
        
    }

    h3 {
        font-size: 1.1rem;
        font-weight: 600;

    }
    p {
        font-size: 1rem;
        
        

    }
}
Label{
    margin-bottom:5px;
    text-align:left;
    font-weight:bold;
    font-size:small;
}
.FormClass{
    display:grid;
    
   
    margin:auto;
    justify-content: space-around;
    align-items: center;
    max-width: 600px;
    padding:10px;
    background-color:var(--lightGrey);
    border-radius: 10px;
}
.PayslipBody{
    max-height:80vh;
    overflow:scroll;
}
.Lineitem{

    margin-top:15px;
   padding:15px;
    display:grid;
    grid-auto-flow: column;
    grid-template-columns: 1fr 1fr;
    }
.checkLineitem, .timeLineitem{
    display:grid;
    grid-auto-flow: column;
    grid-template-columns: 1fr 1fr;
    padding:5px;
    margin:5px;
    background-color: var(--lightGrey)
    
}    
.checkLineitem:hover, .timeLineitem:hover{
    background-color: var(--Grey)
}
.info{
    display:grid;
    grid-auto-flow:column;
    text-align:left;
    margin-left:50px;

}
.timeLineitem{
    grid-template-columns: repeat(8, 1fr);
}


.PaytypeLineitem,.PayrateLineitem,.AdditionListLine{


display:grid;
grid-auto-flow: column;
grid-template-columns: repeat(5, 1fr);
padding:10px;


}
.formVariables{
    width:70%;
    margin:auto;
    background-color: var(--secondaryColor)
}
.AdditionListLine{
    grid-template-columns: repeat(8, 1fr);
}


.PayslipLineItem, .AdditionLineitem,.currentPayslipLineitem{
max-width:90%;
background-color:var(--lightGrey);
margin:auto;
display:grid;
grid-auto-flow: column;
justify-content:space-around;
grid-template-columns: 5fr repeat(4, 1fr);
padding:10px;
}
.currentPayslipLineitem{
    grid-template-columns: 8fr 1fr;
    margin-top:5px;
    border-radius:5%;
    box-shadow: 0 5px 9px white inset;
}
.currentPayslipLinedata{
   
    display:grid;
    grid-template-columns: repeat(4, 1fr);;
    margin-top:5px;
    border-radius:5%;
   padding:5px;
    box-shadow: 0 5px 9px white inset;
}
.AdditionLineitem{
    grid-template-columns: 5fr 5fr repeat(3, 1fr);
}
.PayslipText{
    text-align:left;
   
}
.PayslipNumbers{
    text-align:right;
   
}
.Heading{
    background-color: var(--primaryColor)
}
.highlight{
    background-color:green;
}
.SummaryLine{
display:grid;
grid-auto-flow:column;
max-width:90%;
margin:auto;

}
.transaction{
    display:grid;
    grid-auto-flow:column;
    grid-template-columns: repeat(8, 1fr);
    justify-content:space-around;

}
.ListHead{
    display:grid;
    background-color: var(--lightGrey);
    position:sticky;
    top:55px;
    z-index: 1000;


}
.Avatar{
    width:100px;
    height:100px;
    border-radius: 50%;
}
.injuryAvatar{
    width:100px;
    height:100px;
    border-radius: 20%;
    background-color:var(--lightGrey);
}
.SingleEmployee{
    display:grid;
    grid-auto-flow:column;
    align-items:center;
    grid-template-columns:1fr;
    
}    
.user{
    display:grid;
    grid-auto-flow: row;
    font-size:xx-small;
}
.error{
    
    justify-content:space-around;
    color: red;
}
.inputsize{
   
    font-size: 16px;
}
.fileList{
    display:grid;
    margin:auto;
    justify-content: space-around;
    border-radius:10px;
    padding:10px;
    
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 6px 10px rgba(0, 0, 0, 0.15), 0 12px 20px rgba(0, 0, 0, 0.2);
}
.NameandButton {
    font-size:xx-small;
    justify-content:space-between
}
.smallPDF{
    height:100px;
    width:80px;
    overflow:hidden;
    
}
.pdf-frame{

    padding:10px;
    background-color: var(--secondaryColor);
    
    justify-content: space-around;
    max-height: 70vh;
    max-width:100%;
    /* overflow: ${props => (props.small ? 'hidden' : 'scroll')}; */

}
.react-pdf__Page{
    background-color:var(--secondaryColor);
    /* zoom: ${props => (props.small ? '20%' : 'normal')}; */

}
element.style{
    background-color:var(--secondaryColor);
    
}
canvas.react-pdf__Page__canvas {
    display: grid;
    object-fit: cover;
    overflow:scroll;
    justify-content: space-around;
    border-radius:20px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 6px 10px rgba(0, 0, 0, 0.15), 0 12px 20px rgba(0, 0, 0, 0.2);
    max-height:100%;
    max-width:100%;
    margin:auto;
    margin-bottom: 50px;
    zoom:60%;
   
   
}
.Signature-container{
    
    justify-content:space-around;
    margin:auto;
    max-width:90%;
    position: fixed;
    bottom: -100%; /* Start off-screen */
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 300px; /* Adjust the height as needed */
    background-color: white;
    transition: bottom 1s cubic-bezier(0.68, -0.55, 0.27, 1.55);
    z-index: 1000; /* Ensure it appears above other content */

    

}
.slide-in {
  bottom: 0; /* Slide into view */
}

.signature-canvas {
    
    /* border: 2px solid #000; */
    border-radius: 5px;
    max-height:450px;
   
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 6px 10px rgba(0, 0, 0, 0.15), 0 12px 20px rgba(0, 0, 0, 0.2);
}
.employeeBody{
    display:grid;
    grid-auto-flow:column;
    max-width:90%;
   
}
.burger{
    opacity:1;
   
}
.FileThumb{
    display:grid;
    grid-auto-flow:column;
    grid-template-columns: 4fr 1fr;
   
}
.Dropzone{
    display:grid;
    margin:auto;
    justify-content:space-around;
    border-radius: 5px;
    min-height:100px;
    max-width:80%;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 6px 10px rgba(0, 0, 0, 0.15), 0 12px 20px rgba(0, 0, 0, 0.2);
}
.DropdownContainer{
    margin:10px;
    border-radius:10px;
    background-color:var(--secondaryColor)
}
.MessageForm{
    position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: white;  /* Adjust based on your design */
  padding: 10px;
  display: flex;
  gap: 10px;
  align-items: center;
  box-shadow: 0px -2px 5px rgba(0, 0, 0, 0.1); /* Optional shadow */
}

.inputsize {
  flex-grow: 1;  /* Makes the input take up available space */
}
.dept-select {
  padding: 0.5rem 1rem;
  border: 2px solid var(--primaryColor);
  border-radius: 12px;
  background: linear-gradient(to right, #ffffff, #e8e8ff);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  margin:auto;
  color: #333;
  outline: none;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
}

.dept-select:hover {
  border-color: #7f7fff;
}

.dept-select:focus {
  border-color: #4d4dff;
  box-shadow: 0 0 0 3px rgba(77, 77, 255, 0.2);
}


@media screen and (max-width: 540px){
    canvas.react-pdf__Page__canvas {
        zoom:60%;
    }
   
}
@media screen and (min-width: 640px) {
    .Signature-container {
    
        height: 450px;
    }
}
@media screen and (min-width: 840px) {
    .Signature-container {
    
        height: 500px;
    }
}

`;